import React from 'react';
import { m } from 'framer-motion';
import { PrimaryButton } from '../ui/PrimaryButton';
import { scrollToId } from '../../utils/scroll';
export function ProblemAgitation() {
  return <section className="bg-bg-primary pb-10 sm:pb-14" data-id="element-162" data-mp="27m6u4xubwks0">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-163" data-mp="27o1fgd9iiewm">
        <m.h2 initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="font-heading text-2xl font-bold leading-snug text-ink sm:text-3xl" data-id="element-164" data-mp="22vgn7g6989v7">
          ¿Harto de que el taller se llene de madera sobrante y de clientes que regatean presupuestos de
          reformas pesadas?
        </m.h2>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.08
      }} className="mt-5 space-y-4 text-left text-base leading-relaxed text-muted sm:text-center sm:text-lg" data-id="element-165" data-mp="2ln13bip7aprq">
          <p data-id="element-166" data-mp="knuupuwilyca">Deja de quemar tus retales o de tener las herramientas acumulando polvo en el trastero.</p>
          <p data-id="element-167" data-mp="opy66jj6p2xk">
            Con el <span className="font-semibold text-ink" data-id="element-168" data-mp="opg61btei4kd">Kit del Taller Rentable</span>, tendrás los
            planos exactos, las medidas en milímetros y la estrategia de venta para fabricar piezas de alto
            margen usando solo tus herramientas de casa (taladro, caladora y lijadora).
          </p>
          <p className="font-semibold text-brown" data-id="element-169" data-mp="13djbmk3j7e8n">
            Fabrica en 40 minutos. Vende en 24 horas. Recupera la rentabilidad de tu habilidad manual.
          </p>
        </m.div>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.16
      }} className="mt-8 flex flex-col items-center" data-id="element-170" data-mp="1cfsgatc4cde4">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} showArrow={false} data-id="element-171" data-mp="lc5ccvcdrbxv">
            ✅ Sí, quiero el Kit por 19€
          </PrimaryButton>
          <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-172" data-mp="gen47766t0qx">
            Acceso inmediato · Pago único · 100% Práctico
          </p>
        </m.div>
      </div>
    </section>;
}